import {Flex} from 'antd';
import {FilterHeader} from './common/FilterHeader';
import {FilterForm} from './common/FilterForm';

export const Filter = () => {
  return (
    <Flex vertical gap="80px" style={{width: '100%'}} data-tour-id="filter-root">
      <FilterHeader />
      {/*
        TBD:
        - need to add one more field to the form (trial number)
        - need to add trial number from the filter page is selected
      */}
      <FilterForm />
    </Flex>
  );
};
